import { Shield } from "lucide-react";

import { Label } from "js/components/ui/label";
import { RadioGroup, RadioGroupItem } from "js/components/ui/radio-group";
import { Switch } from "js/components/ui/switch";

import { StepComponentProps } from "../../Tenants/types";

// Simplified version for contracts - no credit investigation option
export const Step3GuarantorConfigurationContract = ({
  formData,
  updateFormData,
  isAnimating,
}: StepComponentProps) => {
  return (
    <div
      className={`space-y-8 transition-all duration-700 ease-out ${isAnimating ? "opacity-0 translate-y-2" : "opacity-100 translate-y-0"}`}
    >
      <div className="space-y-6">
        <div className="flex items-center gap-3 pb-4">
          <Shield className="w-5 h-5 text-gray-700" />
          <h3 className="text-lg font-semibold text-gray-900">
            Configuración de Garantías
          </h3>
        </div>
        <div className="flex items-center justify-between py-4 px-6 bg-gray-50 rounded-lg border transition-all duration-200 ease-in-out hover:shadow-sm">
          <span className="text-sm font-medium text-gray-700">
            ¿Requieres fiador u obligado solidario?
          </span>
          <Switch
            checked={formData.requiresGuarantor}
            onCheckedChange={(checked) =>
              updateFormData("requiresGuarantor", checked)
            }
            className="data-[state=checked]:bg-gray-900"
          />
        </div>
        {formData.requiresGuarantor && (
          <div className="space-y-6 animate-in fade-in slide-in-from-top-2 duration-500 ease-out border border-gray-200 rounded-lg p-6">
            <h4 className="text-base font-semibold text-gray-900">
              Datos del Fiador/Obligado Solidario
            </h4>
            <div className="space-y-2">
              <Label className="text-sm font-medium text-gray-700">
                Tipo de persona
              </Label>
              <RadioGroup
                value={formData.guarantorType}
                onValueChange={(value) =>
                  updateFormData("guarantorType", value)
                }
                className="grid grid-cols-1 sm:grid-cols-2 gap-3"
              >
                <label
                  htmlFor="guarantor-fisica"
                  className={`relative flex cursor-pointer rounded-md border p-3 transition-all duration-200 ease-in-out hover:bg-gray-50 hover:shadow-sm hover:scale-[1.01] ${
                    formData.guarantorType === "fisica"
                      ? "border-blue-500 bg-blue-50/50 shadow-sm"
                      : "border-gray-300"
                  }`}
                >
                  <RadioGroupItem
                    value="fisica"
                    id="guarantor-fisica"
                    className="mt-0.5"
                  />
                  <div className="ml-2.5">
                    <div className="text-sm font-medium text-gray-900">
                      Persona Física
                    </div>
                    <div className="text-xs text-gray-500 mt-0.5">
                      Individuos con RFC e identificación
                    </div>
                  </div>
                </label>
                <label
                  htmlFor="guarantor-moral"
                  className={`relative flex cursor-pointer rounded-md border p-3 transition-all duration-200 ease-in-out hover:bg-gray-50 hover:shadow-sm hover:scale-[1.01] ${
                    formData.guarantorType === "moral"
                      ? "border-blue-500 bg-blue-50/50 shadow-sm"
                      : "border-gray-300"
                  }`}
                >
                  <RadioGroupItem
                    value="moral"
                    id="guarantor-moral"
                    className="mt-0.5"
                  />
                  <div className="ml-2.5">
                    <div className="text-sm font-medium text-gray-900">
                      Persona Moral
                    </div>
                    <div className="text-xs text-gray-500 mt-0.5">
                      Empresas o entidades legales
                    </div>
                  </div>
                </label>
              </RadioGroup>
            </div>
            <div
              className="grid grid-cols-1 gap-4 animate-in fade-in slide-in-from-bottom-2 duration-500 ease-out fill-mode-both"
              style={{ animationDelay: "150ms" }}
            >
              <div className="py-4 px-6 border border-gray-200 rounded-lg transition-all duration-200 ease-in-out hover:shadow-sm hover:border-gray-300">
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-sm font-medium text-gray-700">
                    ¿Se pedirá propiedad en garantía?
                  </span>
                </div>
                <RadioGroup
                  value={formData.propertyAsGuarantee ? "yes" : "no"}
                  onValueChange={(value) =>
                    updateFormData("propertyAsGuarantee", value === "yes")
                  }
                  className="flex gap-4"
                >
                  <div className="flex items-center space-x-2">
                    <RadioGroupItem value="yes" id="property-yes" />
                    <Label
                      htmlFor="property-yes"
                      className="text-sm text-gray-700"
                    >
                      Sí
                    </Label>
                  </div>
                  <div className="flex items-center space-x-2">
                    <RadioGroupItem value="no" id="property-no" />
                    <Label
                      htmlFor="property-no"
                      className="text-sm text-gray-700"
                    >
                      No
                    </Label>
                  </div>
                </RadioGroup>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
